<div class="form-group">
  <div class="custom-select-wrapper">
    <label class="text-label" [attr.for]="label">{{ label | translate }}</label>

    <div
      class="custom-select"
      [class.open]="isOpen"
      (focus)="isOpen = true"
      (blur)="isOpen = false"
      [class.disabled]="disabled"
      (click)="!disabled && toggleDropdown()"
      tabindex="0"
      role="button"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
      (keydown)="handleKeyboard($event)"
      [ngClass]="{
        open: isOpen,
        disabled: disabled,
        'custom-select-error': showErrors && control?.invalid
      }"
    >
      <span
        [ngClass]="{
          'placeholder-text': !selectedOption,
          'selected-text': selectedOption
        }"
      >
        {{ selectedOption?.[displayProperty] || placeholder | translate }}
      </span>
      <img src="assets/icons/chevron-down.svg" />
      <div *ngIf="isOpen" class="options" @dropdownAnimation>
        <div
          class="option-vehicle-data"
          *ngFor="let option of options; trackBy: trackByFn || defaultTrackBy"
          (click)="selectOption(option, $event)"
        >
          <label>{{ option[displayProperty] | translate }}</label>
        </div>
      </div>
    </div>

    <div *ngIf="showErrors && control?.invalid" class="error-message">
      {{ getErrorMessage() | translate }}
    </div>
  </div>
</div>
